import { render } from "./AddApiKey.vue?vue&type=template&id=04b54428"
import script from "./AddApiKey.vue?vue&type=script&lang=js"
export * from "./AddApiKey.vue?vue&type=script&lang=js"

import "./AddApiKey.vue?vue&type=style&index=0&id=04b54428&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__